import { Avatar } from '../../../../../design-system/avatar/avatar/avatar';
import { Inline } from '../../../../../design-system/inline/inline';
import { Stack } from '../../../../../design-system/stack/stack';
import { cn } from '../../../../../utils/cn';
import { getBeneficiaryName } from '../../../../payments/utils/get-beneficiary-name';

type EmployeeDetailsCardProps = {
  firstName: string;
  lastName: string;
  role?: string;
  employeeId: string;
};

export const EmployeeDetailsCard = ({ firstName, lastName, role, employeeId }: EmployeeDetailsCardProps) => {
  const fullName = getBeneficiaryName({ firstName, lastName });
  const metaTextClass = 'text-sm font-medium tabular-nums leading-[22px] tracking-[-0.28px] text-seapoint-gray-text';

  return (
    <Stack space={1.5} justify="center" align="center" className="rounded-lg bg-seapoint-gray-background-modal py-10">
      <Stack space={2} align="center" className="w-full">
        <Avatar name={fullName} size="xl" />

        <h2 className="text-base font-medium leading-[22px] tracking-tighter-custom text-black">{fullName}</h2>
      </Stack>

      <Inline space={2.5}>
        {role && (
          <>
            <span className={metaTextClass}>{role}</span>
            <span aria-hidden="true" className={cn(metaTextClass, 'text-[8px]')}>
              •
            </span>
          </>
        )}

        <span className={metaTextClass}>ID: {employeeId}</span>
      </Inline>
    </Stack>
  );
};
